import React from 'react';

// This component renders a single skeleton row for the table.
const SkeletonRow = () => (
  <tr>
    {/* Order # */}
    <td>
      <div
        className="skeleton-pulse"
        style={{ width: '60px', height: '20px', borderRadius: '4px' }}
      ></div>
    </td>
    {/* Date */}
    <td>
      <div
        className="skeleton-pulse"
        style={{ width: '100px', height: '20px', borderRadius: '4px' }}
      ></div>
    </td>
    {/* Status */}
    <td>
      <div
        className="skeleton-pulse"
        style={{ width: '90px', height: '20px', borderRadius: '4px' }}
      ></div>
    </td>
    {/* Total */}
    <td>
      <div
        className="skeleton-pulse"
        style={{ width: '70px', height: '20px', borderRadius: '4px' }}
      ></div>
    </td>
    {/* Update Button */}
    <td>
      <div
        className="skeleton-pulse"
        style={{ width: '110px', height: '38px', borderRadius: '4px' }}
      ></div>
    </td>
    {/* Action Button */}
    <td>
      <div
        className="skeleton-pulse"
        style={{ width: '130px', height: '38px', borderRadius: '4px' }}
      ></div>
    </td>
  </tr>
);

// This is the main skeleton component that creates the table body.
const MyOrdersSkeleton = ({ rows = 5 }: { rows?: number }) => {
  return (
    <>
      {/* Self-contained CSS for the pulse animation */}
      <style jsx global>{`
        .skeleton-pulse {
          display: inline-block;
          height: 100%;
          width: 100%;
          background: linear-gradient(
            -90deg,
            #f0f0f0 0%,
            #f8f8f8 50%,
            #f0f0f0 100%
          );
          background-size: 400% 400%;
          animation: pulse 1.2s ease-in-out infinite;
        }
        @keyframes pulse {
          0% {
            background-position: 0% 0%;
          }
          100% {
            background-position: -135% 0%;
          }
        }
      `}</style>
      <tbody className="customer-order__tbody">
        {Array.from({ length: rows }).map((_, index) => (
          <SkeletonRow key={index} />
        ))}
      </tbody>
    </>
  );
};

export default MyOrdersSkeleton;
